import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type SessionExpiredDialogInput = undefined;
export type SessionExpiredDialogResult = true;

@Component({
  selector: 'app-session-expired-dialog',
  templateUrl: './session-expired-dialog.component.html',
  styleUrls: ['./session-expired-dialog.component.scss'],
  standalone: false,
})
export class SessionExpiredDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<
      SessionExpiredDialogComponent,
      SessionExpiredDialogResult
    >,
  ) {
    // The user must explicitly choose to log in again — no dismissing.
    this.dialogRef.disableClose = true;
  }

  protected loginAgain(): void {
    this.dialogRef.close(true);
  }
}
